<script lang="ts">
  let { color = 'currentColor' } = $props()
</script>

<svg
  width="19"
  height="17"
  viewBox="0 0 19 17"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.2499 10.25V13.75H6.87494V10.25H12.2499Z"
    stroke={color}
    stroke-width="1.5"
  />
  <path
    d="M0.75 16.0146C0.75 16.0146 4.17873 12.0227 4.26155 12.0006C4.34437 11.9785 6.16667 12.4167 6.16667 12.4167M9.91667 9.91667C9.91667 9.91667 6.69529 4.30028 6.75049 4.1071C6.80569 3.91392 13.9668 0.728031 14.0938 0.750114C14.2208 0.772198 17.7876 4.83046 17.8207 4.985C17.8539 5.13953 17.4701 6.47301 17.4701 6.47301L17.1195 7.96101M18.25 16.0146C18.25 16.0146 14.8213 12.0227 14.7384 12.0006C14.6556 11.9785 12.8333 12.4167 12.8333 12.4167"
    stroke={color}
    stroke-width="1.5"
    stroke-linecap="round"
  />
</svg>
